import type { Template } from "@/types";

export const LA_05_H2_V3: Template[] = [
{
    id: "la-05-h2v3-01",
    name: "LA 01 - H2V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h2_v3_01.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 131, y: 42, width: 185, height: 263, rotation: 0, imageRotation: 0 },
            { id: "2", x: 131, y: 312, width: 185, height: 122, rotation: 0, imageRotation: 0 },
            { id: "3", x: 322, y: 42, width: 184, height: 263, rotation: 0, imageRotation: 0 },
            { id: "4", x: 322, y: 312, width: 184, height: 122, rotation: 0, imageRotation: 0 },
            { id: "5", x: 779, y: 0, width: 352, height: 476, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h2v3-02",
    name: "LA 02 - H2V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h2_v3_02.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 144, y: 0, width: 350, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 768, y: 41, width: 184, height: 122, rotation: 0, imageRotation: 0 },
            { id: "3", x: 768, y: 170, width: 184, height: 263, rotation: 0, imageRotation: 0 },
            { id: "4", x: 958, y: 41, width: 185, height: 122, rotation: 0, imageRotation: 0 },
            { id: "5", x: 958, y: 170, width: 185, height: 263, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h2v3-03",
    name: "LA 03 - H2V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h2_v3_03.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 144, y: 0, width: 350, height: 476, rotation: 0, imageRotation: 0 },
            { id: "2", x: 768, y: 41, width: 184, height: 122, rotation: 0, imageRotation: 0 },
            { id: "3", x: 768, y: 170, width: 184, height: 263, rotation: 0, imageRotation: 0 },
            { id: "4", x: 959, y: 41, width: 185, height: 263, rotation: 0, imageRotation: 0 },
            { id: "5", x: 959, y: 311, width: 185, height: 122, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h2v3-04",
    name: "LA 04 - H2V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h2_v3_04.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 190, y: 46, width: 257, height: 385, rotation: 0, imageRotation: 0 },
            { id: "2", x: 765, y: 46, width: 382, height: 255, rotation: 0, imageRotation: 0 },
            { id: "3", x: 765, y: 307, width: 90, height: 123, rotation: 0, imageRotation: 0 },
            { id: "4", x: 862, y: 307, width: 188, height: 123, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1058, y: 307, width: 89, height: 123, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h2v3-05",
    name: "LA 05 - H2V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h2_v3_05.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 138, y: 46, width: 362, height: 218, rotation: 0, imageRotation: 0 },
            { id: "2", x: 138, y: 271, width: 237, height: 160, rotation: 0, imageRotation: 0 },
            { id: "3", x: 382, y: 271, width: 118, height: 160, rotation: 0, imageRotation: 0 },
            { id: "4", x: 729, y: 71, width: 223, height: 336, rotation: 0, imageRotation: 0 },
            { id: "5", x: 960, y: 71, width: 222, height: 336, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h2v3-06",
    name: "LA 06 - H2V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h2_v3_06.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 57, y: 61, width: 523, height: 354, rotation: 0, imageRotation: 0 },
            { id: "2", x: 792, y: 61, width: 326, height: 205, rotation: 0, imageRotation: 0 },
            { id: "3", x: 792, y: 273, width: 104, height: 143, rotation: 0, imageRotation: 0 },
            { id: "4", x: 904, y: 273, width: 104, height: 143, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1015, y: 273, width: 104, height: 143, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h2v3-07",
    name: "LA 07 - H2V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h2_v3_07.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 79, width: 211, height: 318, rotation: 0, imageRotation: 0 },
            { id: "2", x: 219, y: 79, width: 466, height: 318, rotation: 0, imageRotation: 0 },
            { id: "3", x: 693, y: 79, width: 107, height: 156, rotation: 0, imageRotation: 0 },
            { id: "4", x: 693, y: 242, width: 107, height: 156, rotation: 0, imageRotation: 0 },
            { id: "5", x: 808, y: 79, width: 466, height: 318, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h2v3-08",
    name: "LA 08 - H2V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h2_v3_08.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 190, width: 174, height: 255, rotation: 0, imageRotation: 0 },
            { id: "2", x: 181, y: 190, width: 361, height: 255, rotation: 0, imageRotation: 0 },
            { id: "3", x: 549, y: 190, width: 174, height: 255, rotation: 0, imageRotation: 0 },
            { id: "4", x: 730, y: 190, width: 360, height: 255, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1098, y: 190, width: 176, height: 255, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h2v3-09",
    name: "LA 09 - H2V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h2_v3_09.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 88, y: 41, width: 263, height: 394, rotation: 0, imageRotation: 0 },
            { id: "2", x: 358, y: 41, width: 262, height: 394, rotation: 0, imageRotation: 0 },
            { id: "3", x: 628, y: 41, width: 262, height: 394, rotation: 0, imageRotation: 0 },
            { id: "4", x: 897, y: 41, width: 288, height: 195, rotation: 0, imageRotation: 0 },
            { id: "5", x: 897, y: 243, width: 288, height: 193, rotation: 0, imageRotation: 0 }
    ],
},

{
    id: "la-05-h2v3-10",
    name: "LA 10 - H2V3",
    albumType: "LA",
    thumbnail: "/thumbnails/LA/AR_2.50/la-05-h2_v3_10.png",
    size: [1274, 476],
    style: {},
    slots: [
            { id: "1", x: 0, y: 79, width: 211, height: 318, rotation: 0, imageRotation: 0 },
            { id: "2", x: 219, y: 79, width: 466, height: 318, rotation: 0, imageRotation: 0 },
            { id: "3", x: 693, y: 79, width: 466, height: 318, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1167, y: 79, width: 107, height: 156, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1167, y: 241, width: 107, height: 156, rotation: 0, imageRotation: 0 }
    ],
}
];